import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const PrimeTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--cac-primary-50)',
      100: 'var(--cac-primary-100)',
      200: 'var(--cac-primary-200)',
      300: 'var(--cac-primary-300)',
      400: 'var(--cac-primary-400)',
      500: 'var(--cac-primary-500)',
      600: 'var(--cac-primary-600)',
      700: 'var(--cac-primary-700)',
      800: 'var(--cac-primary-800)',
      900: 'var(--cac-primary-900)',
      950: 'var(--cac-primary-950)',
    },
    colorScheme: {
      light: {
        primary: {
          color: 'var(--cac-primary)',
          contrastColor: '#ffffff',
          hoverColor: 'var(--cac-primary-hover)',
          activeColor: 'var(--cac-primary-active)',
        },
        highlight: {
          background: 'var(--cac-primary-highlight)',
          focusBackground: 'var(--cac-primary-highlight-focus)',
          color: 'var(--cac-primary-700)',
          focusColor: 'var(--cac-primary-800)',
        },
      },
    },
    focusRing: {
      color: 'var(--cac-primary)',
      shadow: '0 0 0 0.2rem var(--cac-primary-focus-ring)',
    },
  },
});
